const categories = {
  adult: 'adult',
  gambling: 'gambling',
  social: 'social',
};

export default categories;
